module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-database-3.4443e298.svg";